/* eslint-disable import/named */
import * as awilix from 'awilix';

import makeHTTPService, {
    HTTPService,
} from '@lib/infra/HTTPService/HTTPService';

import { CurrencyServices } from '@lib/infra/currency/currency.service';
import { YoutubeService } from '@lib/infra/youtube/youtube.service';
import { ITiktokRepository } from '@lib/domain/tiktok/interface';
import { TiktokRepository } from '@lib/infra/tiktok/TiktokRepository';
import { OrderRepository } from '@lib/infra/order/OrderRepository';
import { IOrderRepository } from '@lib/domain/order/interface';
import { IInstagramRepository } from '@lib/domain/instagram/interface';
import { InstagramRepository } from '@lib/infra/instagram/InstagramRepository';
import { ITwitchRepository } from '@lib/domain/twitch/interface';
import { TwitchRepository } from '@lib/infra/twitch/TwitchRepository';
import { CardinityService } from './infra/payments/cardinity-service';
import { ContactService } from './infra/contact';
import { ITwitterRepository } from './domain/twitter/interface';
import { TwitterRepository } from './infra/twitter/twitterRepository';
import { ICouponRepository } from './domain/coupon';
import { CouponRepository } from './infra/coupon/CouponRepository';
import { SettingService } from './infra/setting/setting.service';
import { CheckoutService } from './infra/payments/checkout-service';

export interface Cradle {
    // services
    httpService: HTTPService;
    currencyService: CurrencyServices;
    youtubeService: YoutubeService;
    cardinityService: CardinityService;
    contactService: ContactService;
    settingService: SettingService;
    // repositories
    orderRepository: IOrderRepository;
    couponRepository: ICouponRepository;
    tiktokRepository: ITiktokRepository;
    instagramRepository: IInstagramRepository;
    twitterRepository: ITwitterRepository;
    twitchRepository: ITwitchRepository;
    checkoutService: CheckoutService;
}

// Create the container and set the injectionMode to PROXY (which is also the default).
const container = awilix.createContainer<Cradle>();

/* ------------- Infra ------------- */
container
    // services
    .register({
        httpService: awilix.asFunction(makeHTTPService).singleton(),
        currencyService: awilix.asClass(CurrencyServices).singleton(),
        youtubeService: awilix.asClass(YoutubeService).singleton(),
        cardinityService: awilix.asClass(CardinityService),
        contactService: awilix.asClass(ContactService).singleton(),
        settingService: awilix.asClass(SettingService).singleton(),
        checkoutService: awilix.asClass(CheckoutService).singleton(),
    })
    // repositories
    .register({
        orderRepository: awilix.asClass(OrderRepository),
        tiktokRepository: awilix.asClass(TiktokRepository),
        twitchRepository: awilix.asClass(TwitchRepository),
        instagramRepository: awilix.asClass(InstagramRepository),
        twitterRepository: awilix.asClass(TwitterRepository),
        couponRepository: awilix.asClass(CouponRepository),
    });

/* ------------- App ------------- */

export default container;
